import { __decorate } from "tslib";
import { AutoEncoder, EnumDecoder, field } from '@simonbackx/simple-encoding';
import { PaymentMethod } from '../../PaymentMethod';
import { IDRegisterCart, RegisterCart } from './RegisterCart';
/**
 * Contains all information about a given checkout
 */
export class RegisterCheckout {
    constructor() {
        this.cart = new RegisterCart();
        this.paymentMethod = PaymentMethod.Unknown;
    }
    convert() {
        return IDRegisterCheckout.create(Object.assign({}, this, {
            cart: this.cart.convert(),
        }));
    }
}
/**
 * Contains all information about a given checkout
 */
export class IDRegisterCheckout extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.cart = IDRegisterCart.create({});
        this.paymentMethod = PaymentMethod.Unknown;
    }
    convert(organization, members) {
        const checkout = new RegisterCheckout();
        checkout.cart = this.cart.convert(organization, members);
        checkout.paymentMethod = this.paymentMethod;
        return checkout;
    }
}
__decorate([
    field({ decoder: IDRegisterCart })
], IDRegisterCheckout.prototype, "cart", void 0);
__decorate([
    field({ decoder: new EnumDecoder(PaymentMethod) })
], IDRegisterCheckout.prototype, "paymentMethod", void 0);
//# sourceMappingURL=RegisterCheckout.js.map